import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { FormTitle, DatePickerField, Text, ReadOnlyTextField } from "ui-components/Form";

function ASNDetail({ detailRender, control, errors, getValues, mode = "ADD" }) {
  function renderFn(property, index, length) {
    const [status] = getValues(["status"]);
    const { size, disabled, editable, ...data } = property;
    const xs = 6/2
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(status !== "Open" && { type: "readonly" }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit ASN Detail" : "Add ASN Detail"} />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ASNDetail;
